'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'rocket-launch';
var width = 512;
var height = 512;
var aliases = [128640];
var unicode = 'e027';
var svgPathData = ['M.6 486c-.4 14.6 11.2 26.2 25.9 25.9 34.5-.8 95.1-7 126.4-38.3 31.5-31.5 31.5-82.5 0-114s-82.5-31.5-114 0C7.6 390.9 1.4 451.6 .6 486zm29-246.5C16.8 260.9 32.1 288 57 288l103.5 0c14.2-67.4 34.3-119.7 58.1-160l-95 0c-16.9 0-32.5 8.8-41.2 23.3L29.6 239.5zm27.6 202c.7-12.8 3.7-31.2 13.7-41.3 11.4-11.4 30-11.4 41.4 0s11.4 30 0 41.4c-10.1 10.1-28.5 13-41.3 13.7-8 .5-14.3-5.9-13.9-13.9zM224.5 352l0 103.5c0 24.9 27.1 40.2 48.5 27.4L361.2 430c14.5-8.7 23.3-24.3 23.3-41.2l0-95c-40.3 23.8-92.6 43.9-160 58.1z', 'M160.5 288c59.6-283.1 224-298.9 323.6-284.3 12.8 1.9 22.8 11.9 24.6 24.6 14.6 99.6-1.2 264-284.3 323.6 0-35.3-28.7-64-64-64zm272-160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRocketLaunch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;